var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0342 15.9697C16.7413 15.6768 16.2665 15.6768 15.9736 15.9697C15.6807 16.2626 15.6807 16.7374 15.9736 17.0303L17.0342 15.9697ZM15.9736 17.0303L20.4736 21.5303L21.5342 20.4697L17.0342 15.9697L15.9736 17.0303ZM19.7539 10C19.7539 4.61522 15.3887 0.25 10.0039 0.25V1.75C14.5603 1.75 18.2539 5.44365 18.2539 10H19.7539ZM10.0039 0.25C4.61913 0.25 0.253906 4.61522 0.253906 10H1.75391C1.75391 5.44365 5.44756 1.75 10.0039 1.75V0.25ZM0.253906 10C0.253906 15.3848 4.61913 19.75 10.0039 19.75V18.25C5.44756 18.25 1.75391 14.5563 1.75391 10H0.253906ZM10.0039 19.75C15.3887 19.75 19.7539 15.3848 19.7539 10H18.2539C18.2539 14.5563 14.5603 18.25 10.0039 18.25V19.75Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.03591316c521e9947d662d4756d928fe.svg";
export { ForwardRef as ReactComponent };